var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [_vm._v("点货单详情")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "icon-fresh",
              attrs: { size: "mini", icon: "el-icon-refresh" },
              on: {
                click: function($event) {
                  return _vm.fetchData(true)
                }
              }
            },
            [_vm._v("刷新")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "blockinfo" },
        [
          _vm.resData
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("点货单ID：")]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.resData.pici_id))])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("类型：")]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.resData.type_txt))])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("包裹号：")]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "buttonText",
                                  attrs: {
                                    href:
                                      "#/home/supply/package-list?pici=" +
                                      _vm.resData.pici_no,
                                    target: "_blank"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.resData.package_no))]
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("批次号：")]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.resData.pici_no))]),
                              _vm._v(" "),
                              _c("img", {
                                staticStyle: {
                                  width: "150px",
                                  "vertical-align": "middle"
                                },
                                attrs: {
                                  src:
                                    "http://erp.yishouapp.com/barcode.php?text=" +
                                    _vm.resData.pici_no
                                }
                              })
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("代采组：")]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.resData.pgname))])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("包裹生成时间：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.package_create_time))
                              ])
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("创建人：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.admin_name))
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("商家：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.supply_name))
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("仓库：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.origin_txt))
                              ])
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("创建时间：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.create_time))
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _vm.resData && _vm.resData.package_img
                                ? _c("span", [
                                    _vm._v(
                                      "收包图片(" +
                                        _vm._s(_vm.resData.package_img.length) +
                                        ")："
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      { name: "viewer", rawName: "v-viewer" }
                                    ],
                                    staticStyle: {
                                      width: "40px",
                                      height: "40px",
                                      overflow: "hidden",
                                      cursor: "pointer",
                                      display: "inline-block",
                                      "vertical-align": "text-top"
                                    }
                                  },
                                  _vm._l(_vm.resData.package_img, function(
                                    item,
                                    index
                                  ) {
                                    return _c("img", {
                                      key: index,
                                      staticStyle: {
                                        width: "100%",
                                        height: "100%",
                                        "vertical-align": "middle"
                                      },
                                      attrs: { src: item }
                                    })
                                  }),
                                  0
                                )
                              ])
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "20px" } },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.resData.pici_goods_data, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "goods_eff_num",
                  label: "有效商品",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "goods_inv", label: "不良品", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "no_data_num",
                  label: "无数据商品",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "no_data_num_goods",
                  label: "其中:无数据点货",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "recall_num",
                  label: "撤标商品",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "note",
                  label: "备注",
                  align: "center",
                  width: "200px"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            placeholder: "请填写备注"
                          },
                          model: {
                            value: _vm.chayiRemarks,
                            callback: function($$v) {
                              _vm.chayiRemarks = $$v
                            },
                            expression: "chayiRemarks"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "20px" } },
        [
          _c(
            "div",
            { staticClass: "card-title" },
            [
              _c("div", [
                _vm._v("有效商品（" + _vm._s(_vm.effGoods.total) + "）")
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  staticClass: "demo-form-inline",
                  attrs: {
                    inline: true,
                    model: _vm.filteredEffGoods,
                    size: "mini"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { placeholder: "商品名称" },
                        model: {
                          value: _vm.filteredEffGoods.goods_name,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.filteredEffGoods,
                              "goods_name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "filteredEffGoods.goods_name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { placeholder: "商品货号" },
                        model: {
                          value: _vm.filteredEffGoods.goods_no,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.filteredEffGoods,
                              "goods_no",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "filteredEffGoods.goods_no"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { placeholder: "sku" },
                        model: {
                          value: _vm.filteredEffGoods.sku,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.filteredEffGoods,
                              "sku",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "filteredEffGoods.sku"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.getEffGoods }
                        },
                        [_vm._v("查询")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.effGoods.data, border: "", height: "400" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "dbrid", label: "打标编号", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "pgname", label: "代采组", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "goods_img",
                  label: "商品图片",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          {
                            directives: [
                              { name: "viewer", rawName: "v-viewer" }
                            ],
                            staticStyle: {
                              width: "40px",
                              height: "40px",
                              overflow: "hidden",
                              cursor: "pointer",
                              display: "inline-block"
                            }
                          },
                          _vm._l(scope.row.goods_img, function(item, index) {
                            return _c("img", {
                              key: index,
                              staticStyle: { width: "100%", height: "100%" },
                              attrs: { src: item }
                            })
                          }),
                          0
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "goods_name",
                  label: "商品名称",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "goods_no", label: "商品货号", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "co_val", label: "颜色", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "si_val", label: "尺码", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "sku", label: "sku", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "market_price",
                  label: "代采价",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "dbid", label: "打标ID", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "type_text", label: "类型", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "admin_name", label: "打标人", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "create_time",
                  label: "打标时间",
                  align: "center"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "right", padding: "25px" } },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.effGoods.current_page,
                  background: "",
                  layout: "total, prev, pager, next, jumper ",
                  total: _vm.effGoods.total,
                  "page-size": 10
                },
                on: {
                  "update:currentPage": function($event) {
                    return _vm.$set(_vm.effGoods, "current_page", $event)
                  },
                  "update:current-page": function($event) {
                    return _vm.$set(_vm.effGoods, "current_page", $event)
                  },
                  "current-change": _vm.getEffGoods
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "20px" } },
        [
          _c(
            "div",
            { staticClass: "card-title" },
            [
              _c("div", [
                _vm._v("不良品商品（" + _vm._s(_vm.invalidGoods.total) + "）")
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  staticClass: "demo-form-inline",
                  attrs: {
                    inline: true,
                    model: _vm.filteredInvalidGoods,
                    size: "mini"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { placeholder: "商品名称" },
                        model: {
                          value: _vm.filteredInvalidGoods.goods_name,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.filteredInvalidGoods,
                              "goods_name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "filteredInvalidGoods.goods_name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { placeholder: "商品货号" },
                        model: {
                          value: _vm.filteredInvalidGoods.goods_no,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.filteredInvalidGoods,
                              "goods_no",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "filteredInvalidGoods.goods_no"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { placeholder: "sku" },
                        model: {
                          value: _vm.filteredInvalidGoods.sku,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.filteredInvalidGoods,
                              "sku",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "filteredInvalidGoods.sku"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.getInvalidGoods }
                        },
                        [_vm._v("查询")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.invalidGoods.data, border: "", height: "400" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "dbrid", label: "打标编号", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "pgname", label: "代采组", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "goods_img",
                  label: "商品图片",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          {
                            directives: [
                              { name: "viewer", rawName: "v-viewer" }
                            ],
                            staticStyle: {
                              width: "40px",
                              height: "40px",
                              overflow: "hidden",
                              cursor: "pointer",
                              display: "inline-block"
                            }
                          },
                          _vm._l(scope.row.goods_img, function(item, index) {
                            return _c("img", {
                              key: index,
                              staticStyle: { width: "100%", height: "100%" },
                              attrs: { src: item }
                            })
                          }),
                          0
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "goods_name",
                  label: "商品名称",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "goods_no", label: "商品货号", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "co_val", label: "颜色", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "si_val", label: "尺码", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "sku", label: "sku", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "market_price",
                  label: "代采价",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "dbid", label: "打标ID", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "type_text", label: "类型", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "blp_note", label: "备注", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "admin_name", label: "打标人", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "create_time",
                  label: "打标时间",
                  align: "center"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "right", padding: "25px" } },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.invalidGoods.current_page,
                  background: "",
                  layout: "total, prev, pager, next, jumper ",
                  total: _vm.invalidGoods.total,
                  "page-size": 10
                },
                on: {
                  "update:currentPage": function($event) {
                    return _vm.$set(_vm.invalidGoods, "current_page", $event)
                  },
                  "update:current-page": function($event) {
                    return _vm.$set(_vm.invalidGoods, "current_page", $event)
                  },
                  "current-change": _vm.getInvalidGoods
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "20px" } },
        [
          _c("div", { staticClass: "card-title" }, [
            _c("div", [
              _vm._v("无数据商品（" + _vm._s(_vm.noDataGoods.num) + "）")
            ])
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.noDataGoods.list, border: "", height: "400" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "ndgid", label: "无数据标id", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "img", label: "点货标", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            _vm._s(scope.row.co_val) +
                              "/" +
                              _vm._s(scope.row.si_val)
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(scope.row.goods_no))])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "stock_source",
                  label: "入库类型",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "img", label: "商品图片", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          {
                            directives: [
                              { name: "viewer", rawName: "v-viewer" }
                            ],
                            staticStyle: {
                              width: "40px",
                              height: "40px",
                              overflow: "hidden",
                              cursor: "pointer",
                              display: "inline-block"
                            }
                          },
                          _vm._l(scope.row.middle_img, function(item, index) {
                            return _c("img", {
                              key: index,
                              staticStyle: { width: "100%", height: "100%" },
                              attrs: { src: item }
                            })
                          }),
                          0
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "pgname", label: "代采组", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "dbid", label: "打标id", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "admin_name", label: "创建人", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "note", label: "备注", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "create_time",
                  label: "创建时间",
                  align: "center"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "right", padding: "25px" } },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.noDataGoods.current_page,
                  background: "",
                  layout: "total, prev, pager, next, jumper ",
                  total: _vm.noDataGoods.total,
                  "page-size": 10
                },
                on: {
                  "update:currentPage": function($event) {
                    return _vm.$set(_vm.noDataGoods, "current_page", $event)
                  },
                  "update:current-page": function($event) {
                    return _vm.$set(_vm.noDataGoods, "current_page", $event)
                  },
                  "current-change": _vm.getNoDataGoods
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "20px" } },
        [
          _c("div", { staticClass: "card-title" }, [
            _c("div", [
              _vm._v("撤标商品（" + _vm._s(_vm.recallBiao.count) + "）")
            ])
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.recallBiao.data, border: "", height: "400" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "dbid", label: "打标id", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "pgname", label: "代采组", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "goods_img",
                  label: "商品图片",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          {
                            directives: [
                              { name: "viewer", rawName: "v-viewer" }
                            ],
                            staticStyle: {
                              width: "40px",
                              height: "40px",
                              overflow: "hidden",
                              cursor: "pointer",
                              display: "inline-block"
                            }
                          },
                          _vm._l(scope.row.goods_img, function(item, index) {
                            return _c("img", {
                              key: index,
                              staticStyle: { width: "100%", height: "100%" },
                              attrs: { src: item }
                            })
                          }),
                          0
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "goods_no", label: "商品货号", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "co_val", label: "颜色", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "si_val", label: "尺码", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "sku", label: "sku", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "market_price",
                  label: "代采价",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "recall_type",
                  label: "撤标类型",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "create_admin_name",
                  label: "打标人",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "create_time",
                  label: "打标时间",
                  align: "center"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "right", padding: "25px" } },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.recallBiao.current_page,
                  background: "",
                  layout: "total, prev, pager, next, jumper ",
                  total: _vm.recallBiao.count,
                  "page-size": 10
                },
                on: {
                  "update:currentPage": function($event) {
                    return _vm.$set(_vm.recallBiao, "current_page", $event)
                  },
                  "update:current-page": function($event) {
                    return _vm.$set(_vm.recallBiao, "current_page", $event)
                  },
                  "current-change": _vm.getRecallBiaoFun
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "div",
            { staticClass: "card-title" },
            [
              _c("div", [_vm._v("操作日志")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "auto" },
                  attrs: {
                    type: "text",
                    icon: _vm.filterFold
                      ? "el-icon-arrow-down"
                      : "el-icon-arrow-up"
                  },
                  on: { click: _vm.toggleFilter }
                },
                [_vm._v(_vm._s(_vm.filterFold ? "展开筛选" : "收起筛选"))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("el-collapse-transition", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.filterFold,
                    expression: "!filterFold"
                  }
                ]
              },
              [
                _vm.operationLog
                  ? _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.operationLog.list,
                          border: "",
                          height: "400"
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "operator_name",
                            label: "操作人",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "action_value",
                            label: "操作",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "create_date",
                            label: "操作时间",
                            align: "center"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-title" }, [
      _c("div", [_vm._v("差异审核")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d18191ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d18191ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/TallyingDetail.vue
// module id = null
// module chunks = 